import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './hoc/WithAuthLayout/App.module.css';
import Login from 'components/Auth/Login/Login';
import TargetGroupView from 'views/TargetGroupView/TargetGroupView';
import ManageUsersView from 'views/ManageUsersView/ManageUsersView';
import IntegrationsView from 'views/IntegrationsView/IntegrationsView';
import CompanyView from 'views/CompanyView/CompanyView';
import AddCompanyView from 'views/AddCompanyView/AddCompanyView';
import ScanSetupView from 'views/ScanSetupView/ScanSetupView';
import ReportView from './views/ReportView/ReportView';
import WithAuthLayout from './hoc/WithAuthLayout';
import ScansListView from './views/ScansListView/ScansListView';
import ScansDetailsView from './views/ScanDetailsView/ScanDetailsView';
import CompaniesListView from './views/CompaniesListView/CompaniesListView';
import AddParticipantsView from './views/AddParticipantsView/AddParticipantsView';
import SearchView from './views/SearchView/SearchView';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

function App() {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Routes>
                <Route path="/login" element={<Login />} />

                <Route
                    path="/"
                    element={
                        <WithAuthLayout>
                            {/* @ts-ignore*/}
                            <CompaniesListView />
                        </WithAuthLayout>
                    }
                />

                <Route
                    path="/search"
                    element={
                        <WithAuthLayout>
                            {/* @ts-ignore*/}
                            <SearchView />
                        </WithAuthLayout>
                    }
                />

                <Route
                    path="/:companySlug"
                    element={
                        <WithAuthLayout>
                            {/* @ts-ignore*/}
                            <CompanyView groupsType="CANDIDATE" />
                        </WithAuthLayout>
                    }
                />

                <Route
                    path="/:companySlug/scans"
                    element={
                        <WithAuthLayout>
                            {/* @ts-ignore*/}
                            <ScansListView />
                        </WithAuthLayout>
                    }
                />

                <Route
                    path="/:companySlug/internal"
                    element={
                        <WithAuthLayout>
                            {/* @ts-ignore*/}
                            <CompanyView groupsType="INTERNAL" />
                        </WithAuthLayout>
                    }
                />

                <Route
                    path="/:companySlug/motiview"
                    element={
                        <WithAuthLayout>
                            {/* @ts-ignore*/}
                            <CompanyView groupsType="MOTIVIEW" />
                        </WithAuthLayout>
                    }
                />

                <Route
                    path="/:companySlug/scans/:assessmentId"
                    element={
                        <WithAuthLayout>
                            {/* @ts-ignore*/}
                            <ScansDetailsView />
                        </WithAuthLayout>
                    }
                />

                <Route
                    path="/:companySlug/groups/:groupId"
                    element={
                        <WithAuthLayout>
                            {/* @ts-ignore*/}
                            <TargetGroupView />
                        </WithAuthLayout>
                    }
                />

                <Route
                    path="/:companySlug/groups/:groupId/add"
                    element={
                        <WithAuthLayout>
                            {/* @ts-ignore*/}
                            <AddParticipantsView />
                        </WithAuthLayout>
                    }
                />

                <Route
                    path="/:companySlug/groups/:groupId/results/:candidateId"
                    element={
                        <WithAuthLayout addLayout={false}>
                            {/* @ts-ignore*/}
                            <ReportView />
                        </WithAuthLayout>
                    }
                />

                <Route
                    path="/:companySlug/manage-team"
                    element={
                        <WithAuthLayout>
                            {/* @ts-ignore*/}
                            <ManageUsersView />
                        </WithAuthLayout>
                    }
                />
                <Route
                    path="/:companySlug/integrations"
                    element={
                        <WithAuthLayout>
                            {/* @ts-ignore*/}
                            <IntegrationsView />
                        </WithAuthLayout>
                    }
                />
                <Route
                    path="/add-company"
                    element={
                        <WithAuthLayout>
                            {/* @ts-ignore*/}
                            <AddCompanyView />
                        </WithAuthLayout>
                    }
                />
                <Route
                    path="/:companySlug/new"
                    element={
                        <WithAuthLayout>
                            {/* @ts-ignore*/}
                            <ScanSetupView
                                isGroupSetup={true}
                                isInternal={false}
                                isMotiview={false}
                            />
                        </WithAuthLayout>
                    }
                />
                <Route
                    path="/:companySlug/internal/new"
                    element={
                        <WithAuthLayout>
                            {/* @ts-ignore*/}
                            <ScanSetupView
                                isGroupSetup={true}
                                isInternal={true}
                                isMotiview={false}
                            />
                        </WithAuthLayout>
                    }
                />
                <Route
                    path="/:companySlug/motiview/new"
                    element={
                        <WithAuthLayout>
                            {/* @ts-ignore*/}
                            <ScanSetupView
                                isGroupSetup={true}
                                isInternal={false}
                                isMotiview={true}
                            />
                        </WithAuthLayout>
                    }
                />
                <Route
                    path="/:companySlug/scans/new"
                    element={
                        <WithAuthLayout>
                            {/* @ts-ignore*/}
                            <ScanSetupView isGroupSetup={false} />
                        </WithAuthLayout>
                    }
                />
            </Routes>
        </LocalizationProvider>
    );
}

export default App;
